import styles from "./SelectCustom.module.scss";

function SelectCustom({
  value,
  onChange,
  options = [],
  placeholder,
  style,
  className,
  disabled = false,
  ...rest
}) {
  return (
    <select
      className={`${styles.select} ${className || ""}`}
      value={value}
      onChange={onChange}
      style={style}
      disabled={disabled}
      {...rest}
    >
      {placeholder && <option value="">{placeholder}</option>}
      {options.map((option) => {
        const optValue = typeof option === "object" ? option.value : option;
        const optLabel = typeof option === "object" ? option.label : option;
        return (
          <option key={optValue} value={optValue}>
            {optLabel}
          </option>
        );
      })}
    </select>
  );
}

export default SelectCustom;
